/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPrescription } from 'app/shared/model/prescription.model';

export interface ITreatmentHistory {
  id?: string;
  cursor?: number;
  diagnose?: string | null;
  diagnoseNotes?: string | null;
  startDate?: number | null;
  endDate?: number | null;
  status?: string | null;
  active?: boolean;
  timestampentry?: number;
  lastupdated?: number;
  microSec?: number;
  consultant?: IDoctor | null;
  patient?: IGlucoUser;
  prescription?: IPrescription;
}

export const defaultValue: Readonly<ITreatmentHistory> = {
  active: false,
};
